<app-modal #modalComponent>
	<div *ngIf="!carrito && !isSub"class="mb-6 flex w-full pb-2 items-center border-b p-6">
		<button (click)="carrito = true; checkout = false" class="flex items-center hover:text-principal-claro focus:text-principal-claro focus:outline-none">
			<span class="icon-flecha-anterior"></span>
		</button>
		<h2 class="flex-1 text-center uppercase text-xl tracking-3xsmall">
			{{ 'buttons.carrito' | translate }}
		</h2>
		<button aria-label="Close" (click)="close()" class="flex items-center text-center hover:text-principal-claro focus:text-principal-claro focus:outline-none">
			<span class="material-icons">close</span>
		</button>
	</div>
	<div class="flex flex-row w-full p-6 pb-2 items-center border-b" *ngIf="carrito && !isSub && isShowCheckout">
		<h2 tabindex="0" class="flex-1 text-center uppercase text-xl font-bold tracking-3xsmall text-principal">
			{{ 'carrito.title' | translate }}
		</h2>
		<button aria-label="Close" (click)="close()" class="flex items-center text-center hover:text-principal-claro focus:text-principal-claro focus:outline-none">
			<span class="material-icons">close</span>
		</button>
	</div>
	<div *ngIf="carrito && !isSub && !isShowCheckout" class="bg-white h-full w-full flex flex-col justify-between">
		<div class="flex flex-row w-full p-6 pb-2 items-center border-b">
			<h2 tabindex="0" class="flex-1 text-center uppercase text-xl font-bold tracking-3xsmall text-principal">
				{{ 'carrito.title' | translate }}
			</h2>
			<button aria-label="Close" (click)="close()" class="flex items-center text-center hover:text-principal-claro focus:text-principal-claro focus:outline-none">
				<span class="material-icons">close</span>
			</button>
		</div>
		<div class="w-full overflow-y-auto mt-4 h-full">
			<div *ngFor="let product of cart; let i = index" class="cart-box flex gap-3 p-3 mb-4 mx-4">
				<div class="w-24 h-24 flex items-stretch relative">
					<div
						*ngIf="sales_price_products[i] != 0"
						class="transform rotate-90 absolute top-2 -right-4 bg-principal font-semibold flex justify-center items-center text-info text-xs font-poppins w-20 h-8 uppercase"
					>
						{{ promotionInfo.name }}
					</div>
					<img
						class="w-full h-full object-cover object-center rounded-lg"
						[src]="product.variation.images.length > 0 ? product.variation.images[0].url : product.product.images.length > 0 ? product.product.images[0].url : default_photo"
						alt=""
					/>
					<!-- <img
            *ngIf="
              product.variation.images.length === 0 || !product.variation.images
            "
            class="w-full h-full object-contain"
            [src]="
              product.variation.image ? product.variation.image : default_photo
            "
            alt=""
          /> -->
				</div>
				<div class="flex-1 flex flex-wrap gap-3 justify-between">
					<div class="w-full text-base relative text-gris-medio">
						<p class="uppercase pr-4 font-semibold">{{ product.variation.name }}</p>
						<!-- <span class="text-gris-claro text-xs product-txt2">SKU: {{ product.variation.product_sku }}</span> -->
						<!-- {{infoVar |json}} -->
						<ul *ngFor="let variant of infoVar[i]; let j = index" class="flex flex-wrap w-full text-gris-claro text-sm">
							<!-- {{i}} - {{variant | json}}  -->
							<li *ngIf="variant != []">
								<b>{{ variant.name }}</b
								>: {{ variant.value }}
							</li>
						</ul>
						<button
							(click)="removeItem(i)"
							class="absolute right-0 top-0 text-lg icon-cerrar text-principal hover:text-principal-hover focus:text-principal-hover rounded-full focus:outline-none"
						></button>
					</div>

					<div class="flex h-8 justify-between gap-4 items-center self-end w-full">
						<div class="flex justify-between rounded-lg border bg-gris-extraclaro border-gris-claro h-8 w-22 items-center">
							<button
								aria-label="Remove one"
								(click)="removeCantidad(i)"
								class="font-bold w-8 h-8 rounded-full text-gris focus:outline-none hover:text-principal focus:text-principal flex items-center justify-center"
							>
								<span class="material-icons-outlined text-sm">remove</span>
							</button>
							<div class="w-8 text-center">
								<p class="text-xs font-semibold">{{ product.variation.quantity }}</p>
							</div>
							<button
								aria-label="Add one more"
								(click)="addCantidad(product)"
								class="font-bold w-8 h-8 rounded-full text-gris focus:outline-none hover:text-principal focus:text-principal flex items-center justify-center"
							>
								<span class="material-icons-outlined text-sm">add</span>
							</button>
						</div>
						<div class="flex h-8 items-center self-end">
							<ng-container *ngIf="!product.variation.isSubscription; else subscribeTemplate">
								<p  class="font-semibold text-lg uppercase h-8 flex items-center whitespace-nowrap"  [ngClass]="product.variation.sale_price > 0 ? 'text-gris-claro line-through': 'text-principal' ">
									{{product.variation.price | currencyPersonalized}}
								</p>
								<p *ngIf="product.variation.sale_price > 0" class="pl-2 text-principal font-semibold text-lg uppercase h-8 flex items-center whitespace-nowrap">
									{{product.variation.sale_price | currencyPersonalized}}
								</p>
							</ng-container>

							<ng-template #subscribeTemplate>
								<p *ngIf="product.variation.sale_price > 0" class="font-semibold text-lg uppercase h-8 flex items-center whitespace-nowrap text-gris-claro line-through">
									{{ product.variation.sale_price | currencyPersonalized }}
								</p>
								<p *ngIf="product.variation.sale_price === 0" class="font-semibold text-lg uppercase h-8 flex items-center whitespace-nowrap text-gris-claro line-through">
									{{ product.variation.price | currencyPersonalized }}
								</p>
								<p class="pl-2 text-principal font-semibold text-lg uppercase h-8 flex items-center whitespace-nowrap">
									{{ product.variation.discountPrice | currencyPersonalized }}
								</p>
							</ng-template>
							
						</div>
					</div>
					<!-- <button (click)="ver(product.product)">ver</button> -->

					<div class="my-2 flex justify-between gap-4 items-center self-end" *ngIf="product.product.variants_options && product.product.variants_options.length > 0">
						<div class="flex h-6 items-center">
							<button
								(click)="changeVariati(product); changeVar = !changeVar"
								*ngIf="!changeVar"
								class="px-4 py-1 text-xs border rounded transition-all bg-red-500 text-white border-red-500"
							>
								Change variant
							</button>
						</div>
						<div *ngIf="changeVar &&  (changeVar && product.product.product_sku == currentChange) == false">
							<p>loading...</p>
						</div>
						<div class="flex justify-between gap-4 items-center self-end" *ngIf="changeVar && product.product.product_sku == currentChange">
							<div *ngFor="let variation of varPropiedades; let i = index">
								<ul class="flex flex-wrap w-full gap-x-3 mb-4 mt-8 md:mt-0 max-w-screen-xl mx-auto">
									<li class="text-base font-bold text-black capitalize w-full">{{ variation.name }}</li>
									<li class="text-gris-medio tracking-4xsmall flex space-x-4 ">
										<button
											*ngFor="let value of variation.values; let j = index"
											class="px-4 py-1 text-xs border rounded transition-all"
											[ngClass]="infoVar[i][0].value == value  ? 'bg-red-500 text-white border-red-500' : 'bg-white text-gray-700 border-gray-300'"
											(click)="selected(variation, value, product.product); changeVar = !changeVar" >
											{{ value }} 
										</button>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- fin for -->
		</div>

		<div class="w-full max-w-xl">
			<!-- <div class="w-full flex flex-row justify-between my-2 text-sm py-1 px-6">
				<p class="text-info uppercase font-normal">Subtotal</p>
				<p class="font-normal">{{ TotalCart | currencyPersonalized }}</p>
			</div>
			<div class="w-full flex flex-row justify-between my-2 text-sm py-1 px-6">
				<p class="text-info uppercase font-normal">Tax</p>
				<p class="font-normal">{{ TotalCart | currencyPersonalized }}</p>
			</div>
			<div class="w-full flex flex-row justify-between my-2 text-sm py-1 px-6">
				<p class="text-info uppercase font-normal">Shipping</p>
				<p class="font-normal">{{ TotalCart | currencyPersonalized }}</p>
			</div> -->

			<div class="w-full flex flex-row justify-between my-4 text-2xl py-2 border-t-2 border-principal px-6">
				<p class="text-gris-medio capitalize font-medium">
					{{ 'carrito.total' | translate }}
				</p>
				<p class="font-bold text-principal">{{ TotalCart | currencyPersonalized }}</p>
			</div>
			<div class="flex flex-col md:flex-col gap-3 my-4 w-full px-6">
				<button
					(click)="close()"
					class="rounded-full w-full uppercase text-center bg-gris-claro text-gris-medio font-medium px-4 py-2 transform hover:scale-110 hover:z-10 transition-transform ease-in-out duration-500"
				>
					Close Cart
				</button>

				<button
					(click)="carrito = false; checkout = true"
					class="rounded-full w-full uppercase text-center font-medium text-white bg-principal px-4 py-2 transform hover:scale-110 hover:z-10 transition-transform ease-in-out duration-500"
				>
					{{ 'buttons.comprarAhora' | translate }}
				</button>

				<!-- <button
					(click)="close()"
					class="rounded-full w-full uppercase text-center bg-black text-white px-4 py-1 transform hover:scale-110 hover:z-10 transition-transform ease-in-out duration-500"
				>
					<img src="/assets/icons/google_pay.svg" alt="visa" class="w-full h-10 mx-auto" />
				</button> -->
			</div>
		</div>
	</div>
	<div *ngIf="isSub" class="flex justify-between w-full bg-principal text-white px-5 py-3">
	
		<p class="flex flex-row gap-2 py-2 px-3">
		  <span class="flex-1 lg:w-full font-poppins font-semibold uppercase text-base tracking-3xsmall">{{'suscripcion.title' | translate}}</span>
		  <!-- <span class="text-principal-hover">Free Shipping</span> -->
		</p>
		<button (click)="close()" aria-label="Close" class="flex items-center text-center py-2 px-3 hover:text-principal-hover focus:text-principal-hover">
		  
		  <span class="material-icons">close</span>
		</button>
	  
	  </div>
	<app-checkout (emitCloseModal)="getEvent($event)"   *ngIf="checkout || isSub || isShowCheckout" class="w-full overflow-y-auto"></app-checkout>

	<app-purchase-detail *ngIf="objectKeys(detail).length > 0"></app-purchase-detail>
</app-modal>

<ng-template #toolbar> </ng-template>
